import { Pano } from "./display/Pano.js";

export class Application {
    constructor() {
        document.querySelectorAll<HTMLElement>(".pano")
            .forEach((p) => {
                const pano = new Pano(p);
            });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Application();
});